import React, { createContext, useState, useEffect, useCallback } from "react";
import Loader from "../components/Loader";

export const CartContext = createContext();

// Definimos la base de la API:
// Si estamos en localhost, apuntamos a la URL absoluta de Hostinger.
// Si estamos en producción, usamos la ruta relativa.
const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "https://espacioanalogico.com.ar/api"
    : "/api";

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [items, setItems] = useState([]);
  const [itemsAdmin, setItemsAdmin] = useState([]);
  const [dbCategories, setDbCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // --- LÓGICA DEL CARRITO ---
  const addToCart = (item) => {
    if (isInCart(item.id)) {
      sumarCantidad(item, (cantidadSeleccionada(item.id) || 0) + 1);
    } else {
      setCart([...cart, { ...item, cantidad: 1 }]);
    }
  };

  const isInCart = (id) => cart.some((producto) => producto.id === id);

  const sumarCantidad = (item, cantidad, formaPago) => {
    const cartActualizado = cart.map((producto) => {
      if (producto.id === item.id) {
        return { ...producto, cantidad, formaPago };
      }
      return producto;
    });
    setCart(cartActualizado);
  };

  const clearCart = () => setCart([]);

  const clearProducto = (id) => {
    const cartFiltrado = cart.filter((producto) => producto.id !== id);
    setCart(cartFiltrado);
  };

  const totalCart = () =>
    cart.reduce((acc, prod) => acc + (prod.cantidad || 0), 0);

  const totalPrecio = () =>
    cart.reduce((acc, prod) => acc + (prod.cantidad || 0) * prod.precio, 0);

  const cantidadSeleccionada = (id) =>
    cart.find((prod) => prod.id === id)?.cantidad;

  const handleModal = () => setShowModal(!showModal);

  // --- LÓGICA DE CARGA ---

  const loadProducts = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/get_products.php`);

      if (!response.ok)
        throw new Error(
          `Error ${response.status}: No se pudo obtener productos`,
        );

      const data = await response.json();
      const rawData = Array.isArray(data) ? data : [];

      setItemsAdmin(rawData);

      const activos = rawData.filter(
        (p) => p.estado?.toLowerCase() !== "pausado",
      );
      setItems(activos);
    } catch (error) {
      console.error("Error cargando productos:", error);
    }
  }, []);

  const loadCategories = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/get_categories.php`);

      if (!response.ok)
        throw new Error(
          `Error ${response.status}: No se pudo obtener categorías`,
        );

      const data = await response.json();
      setDbCategories(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error cargando categorías:", error);
    }
  }, []);

  useEffect(() => {
    const loadAll = async () => {
      setIsLoading(true);
      await Promise.all([loadProducts(), loadCategories()]);
      setIsLoading(false);
    };
    loadAll();
  }, [loadProducts, loadCategories]);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        clearCart,
        clearProducto,
        totalCart,
        totalPrecio,
        cantidadSeleccionada,
        handleModal,
        items,
        itemsAdmin,
        dbCategories,
        loadCategories,
        loadProducts,
        isLoading,
      }}
    >
      {isLoading ? (
        <div className="loader-container">
          <div className="loader">
            <Loader />
          </div>
        </div>
      ) : (
        children
      )}
    </CartContext.Provider>
  );
};
